<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">輔導知能活動設定與登入</span>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <span class="text-danger">*</span>
                            <label for="No">活動編號</label>
                            <div class="input-group">
                                <input id="No" type="number" class="form-control" v-model="vm.No">
                                <div class="input-group-append">
                                    <b-button variant="primary" @click="getActive()">帶入</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.Name" id="Name" label="名稱" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-select v-model="vm.Property" id="Property" label="活動性質" required>
                            <slot name="property"></slot>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-date-input v-model="vm.Start" id="Start" label="日期(起)" required></form-date-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-date-input v-model="vm.End" id="End" label="日期(訖)" required></form-date-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.Place" id="Place" label="地點" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-select v-model="vm.CrossSchool" id="CrossSchool" label="跨校" required>
                            <div is="option" value="false">否</div>
                            <div is="option" value="true">是</div>
                        </form-select>
                    </div>
                    <div class="col-12">
                        <form-textarea v-model="vm.Remark" id="Remark" label="備註" type="text"></form-textarea>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-2 @click="show">報到</b-button>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel" v-if="isedit">
                <div class="card mb-1">
                    <div class="card-body">
                        <file-upload :url="'/api/activityregister/excel?No='+vm.No" @ok="ok"></file-upload>
                    </div>
                    <div class="card-footer">
                        <a href="/template/activityregister.xlsx" class="btn btn-default"><b-icon-arrow-down></b-icon-arrow-down>範本下載</a>
                    </div>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>學號/教師編號</th>
                            <th>姓名</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ActivityRegisterID">
                        <td>{{item.UserNo}}</td>
                        <th>{{item.Name}}</th>
                        <th>
                            <b-button variant="danger" @click="tempdel(item.ActivityRegisterID)">刪除</b-button>
                        </th>
                    </tr>
                    <tr>
                        <td data-th="學號/教師編號">
                            <input v-model="temp.UserNo" type="text" class="form-control" />
                        </td>
                        <td data-th="姓名">
                            <input v-model="temp.Name" type="text" class="form-control" />
                        </td>
                        <td>
                            <div class="form-group">
                                <b-button variant="primary" @click="tempsave">儲存</b-button>
                            </div>
                        </td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'counselingDetail',
        api: '/api/counseling/',
        data: {
            tableData: { count: 0, value: [] },
            pager: {},
            temp: { No: null, UserNo: '', Name: '' }
        },
        vm: { Name: '', Place: '' },
        methods: {
            show: function () {
                if (this.isedit) {
                    this.reload();
                    return
                } else {
                    this.$bvToast.toast('請先儲存活動', { title: '發生錯誤', variant: 'warning', solid: true });
                }
            },
            load: function () {
                return this.$http({ method: 'get', url: 'api/activityregister/Get?No=' + this.vm.No, headers: this.pager })
                    .then(res => {
                        if (res.data) {
                            this.tableData.count = res.data.count;
                            this.tableData.value = res.data.value;
                        } else {
                            this.tableData.count = 0;
                            this.tableData.value = [];
                        }
                    });
            },
            reload: function () {
                this.pager.skip = 0;
                return this.load();
            },
            tempsave: function () {
                this.temp.No = this.vm.No;
                this.$http({ method: 'put', url: 'api/activityregister/Put', data: this.temp })
                    .then(() => { this.reload(); });
            },
            tempdel: function (ActivityRegisterID) {
                this.$http({ method: 'delete', url: 'api/activityregister/Delete/' + ActivityRegisterID })
                    .then(() => { this.reload(); })
            },
            ok: function (e) {
                this.$bvToast.toast('上傳' + e.res.data.totel + ' 新增' + e.res.data.success, { title: '上傳完成', variant: 'success', solid: true });
                this.load();
            },
            getActive: function () {
                if (this.vm.No) {
                    let vue = this.vm;
                    this.$http({ method: 'get', url: 'api/active/Data/' + this.vm.No })
                        .then((res) => {
                            if (res.data) {
                                vue.Name = res.data.name;
                                vue.Place = res.data.place;
                            } else {
                                this.$bvToast.toast('查無資料', { title: '發生錯誤', variant: 'danger', solid: true });
                            }
                        })
                } else {
                    this.$bvToast.toast('請輸入活動編號', { title: '發生錯誤', variant: 'danger', solid: true });
                }
            },
            save: function () {
                alert("hello world");
            }
        }
    });
</script>

<style>
</style>